export enum ProjectStatusEnum {
  ongoing = 0,
  upcoming = 1,
  completed = 2,
  all = 3
}

export class ProjectStatusEnumUtils {
  public static getEnumValue(type: ProjectStatusEnum): string {
    switch (type) {
      case ProjectStatusEnum.ongoing:
        return "Ongoing";
      case ProjectStatusEnum.upcoming:
        return "Upcoming";
      case ProjectStatusEnum.completed:
        return "Completed";
      case ProjectStatusEnum.all:
        return "All";
    }
  }

  public static getProjectStatusEnums(): {
    id: ProjectStatusEnum;
    name: string;
    value: ProjectStatusEnum;
  }[] {
    const options: {
      name: string;
      id: ProjectStatusEnum;
      value: ProjectStatusEnum;
    }[] = [
        {
          id: ProjectStatusEnum.ongoing,
          name: this.getEnumValue(ProjectStatusEnum.ongoing),
          value: ProjectStatusEnum.ongoing,
        },
        {
          id: ProjectStatusEnum.upcoming,
          name: this.getEnumValue(ProjectStatusEnum.upcoming),
          value: ProjectStatusEnum.upcoming,
        },
        {
          id: ProjectStatusEnum.completed,
          name: this.getEnumValue(ProjectStatusEnum.completed),
          value: ProjectStatusEnum.completed,
        },
      ];
    return options;
  }
}
